// frontend/src/components/Requisitions/edit/hooks/useStep1Catalogs.js

import { useEffect, useState } from "react";

import { CATALOG_CANDIDATES, CATALOG_META } from "../constants";
import { fetchFirstOk } from "../api";

const isCatalogItemActive = (item) => {
  if (!item || typeof item !== "object") return false;
  if (!Object.prototype.hasOwnProperty.call(item, "active")) return true;

  const value = item.active;
  if (typeof value === "string") {
    return !["false", "0", "no", "off", "inactive"].includes(value.trim().toLowerCase());
  }
  return Boolean(value);
};

export function useStep1Catalogs() {
  const [catalogs, setCatalogs] = useState({});
  const [loadingStep1, setLoadingStep1] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadAll() {
      setLoadingStep1(true);

      try {
        const keys = Object.keys(CATALOG_META);

        const results = await Promise.allSettled(
          keys.map((key) => fetchFirstOk(CATALOG_CANDIDATES[key]))
        );

        if (cancelled) return;

        const nextCatalogs = {};

        results.forEach((result, index) => {
          const key = keys[index];

          if (result.status === "fulfilled") {
            nextCatalogs[key] = (result.value || []).filter(isCatalogItemActive);
          } else {
            nextCatalogs[key] = [];
            console.error(
              `[catalog] Failed to load "${key}":`,
              result.reason?.message || result.reason
            );
          }
        });

        setCatalogs(nextCatalogs);
      } finally {
        if (!cancelled) {
          setLoadingStep1(false);
        }
      }
    }

    loadAll();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    catalogs,
    loadingStep1,
  };
}
